import { createStore } from 'vuex'
import language from './modules/language'
import session from './modules/session'

// Helpers
const helpers = {
  getWindowWidth() {
    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
  },
  getCurrentYear() {
    return new Date().getFullYear()
  }
}

// Create Vuex Store
const store = createStore({
  state() {
    return {
      // App vital details
      app: {
        name: 'Mabe Test',
        version: process.env.PACKAGE_VERSION,
        copyright: helpers.getCurrentYear()
      },
    }
  },
  getters: {
    // Get App name
    appName: (state) => {
      return state.app.name
    },
    // Get App version
    appVersion: (state) => {
      return state.app.version
    },
    // Get App copyright year
    appCopyright: (state) => {
      return state.app.copyright
    },
  },
  mutations: {
    // Your mutations if any
  },
  modules: {
    session,
    lang: language,
  }
})

export default store